import axios from 'axios';
import { config } from './utils';

export const uploadAssets = async (
  file: any,
  uploadType: string,
  token: string,
) => {
  const formData = new FormData();
  formData.append('uploadType', file);
  return await axios
    .post(
      `${config.BASE_URL}/upload-asset?uploadType=${uploadType}`,
      formData,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error(error, 'error')
      return '';
    });
};
